@if (baseRules?.hasOutstanding && !isReviewPage) {
<h2 class="axis-h4">Hawaii</h2>
@if (reactiveForm) {
<form [formGroup]="reactiveForm">
  <div class="axis-grid">
    @for (control of controls; track $index) {
    @if (
      baseRules[control.baseRuleKey]?.includes("form")
    ) {
    <div class="axis-col-sm-6 axis-col-md-6">
      <div class="axis-form-group" [ngClass]="{
                    'has-axis-required': reactiveForm.get(control.formControlName)?.value === null,
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                  }">
        <label class="axis-control-label"
          for="{{ control.formControlName }}">
          {{ control.label }}
          <span aria-hidden="true" class="axis-required-indicator">*</span>
        </label>

        <axis-dropdown [dataProvider]="control.data" id="{{ control.formControlName }}"
          formControlName="{{ control.formControlName }}"
          (onSelect)="control.selectedPremium = $any($event).premium"></axis-dropdown>
        @if (reactiveForm.get(control.formControlName)?.touched) {
        @if (reactiveForm.get(control.formControlName)?.invalid) {
        <span class="axis-error-block" role="alert">
          Please select the {{ control.label }}.
        </span>
        }
        }
        @if (control.selectedPremium) {
        <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
        }
      </div>
    </div>
    }
    }
  </div>
</form>
}
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
<h2 class="axis-h4">Hawaii</h2>
@if (baseRules["AddedPIPMedicalBenefitsMax_DropDown"]?.includes("show")) {
<div class="axis-grid">
  <div class="axis-col-sm-6 axis-col-lg-4">
    <div class="axis-form-group">
      <label class="axis-control-label">{{ controls[1].label }} </label>
      <div>{{ controls[1].data[0].name }}</div>
    </div>
  </div>
</div>
}
@if (baseRules["AddedPIPMedicalBenefitsMin_DropDown"]?.includes("show")) {
<div class="axis-grid">
  <div class="axis-col-sm-6 axis-col-lg-4">
    <div class="axis-form-group">
      <label class="axis-control-label">{{ controls[2].label }} </label>
      <div>{{ controls[2].data[0].name }}</div>
    </div>
  </div>
</div>
}
@if (baseRules["AddedPIPMedicalBenefits_DropDown"]?.includes("show")) {
<div class="axis-grid">
  <div class="axis-col-sm-6 axis-col-lg-4">
    <div class="axis-form-group">
      <label class="axis-control-label">{{ controls[0].label }} </label>
      <div id="addedpipmedicalbenefits_20k-pdffield-hawaii">{{ controls[0].data[0].name }}</div>
    </div>
  </div>
</div>
}
}